import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getPaintingText, patchPaintingText } from '../../api/api';
import './LoveEditor.css';
import { Modal } from '../../components/Modal';

export const LoveEditor: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [text, setText] = useState<string | null>(null);
    const [notification, setNotification] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!id) return;
        setLoading(true);
        getPaintingText(id)
            .then(data => setText(data.text))
            .catch(() => setText(null))
            .finally(() => setLoading(false));
    }, [id]);

    const handleSave = useCallback(async (newText: string | null) => {
        if (!id) return;
        await patchPaintingText(id, newText);
        setText(newText);
        setNotification(`Текст для картины ${id} обновлён!`);
        setTimeout(() => setNotification(null), 3000);
    }, [id]);

    if (loading) return <div>Загрузка...</div>;
    if (!id) return <div>Некорректный ID картины</div>;

    return (
        <div className="love-editor-bg">
            {notification && (
                <div className="love-editor-notification">{notification}</div>
            )}
            <Modal
                isOpen={true}
                onClose={() => {}}
                showCloseButton={false}
                mode="text"
                value={text}
                onSave={handleSave}
                title={`Картина ${id}`}
                subHeader='Отредактируйте текст для картины'
                placeholder="Введите текст для картины"
            />
        </div>
    );
}; 